/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningsnav1Inputs */

const en_earningsnav1 = /** @type {(inputs: Earningsnav1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earnings`)
};

const de_earningsnav1 = /** @type {(inputs: Earningsnav1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einnahmen`)
};

/**
* | output |
* | --- |
* | "Earnings" |
*
* @param {Earningsnav1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningsnav1 = /** @type {((inputs?: Earningsnav1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningsnav1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningsnav1(inputs)
	return de_earningsnav1(inputs)
});
export { earningsnav1 as "earningsNav" }